export const BASE_WEBSTORE_PRODUCT_URL =
  process.env.VUE_APP_BASE_WEBSTORE_PRODUCT_URL;
export const LOCALE = process.env.VUE_APP_I18N_LOCALE;
